export const CONTACT_URL = 'https://cal.com/fluidn/30min';
export const ADDITIONAL_SUBMISSIONS_PURCHASE_ENTRY = {
    priceId: process.env.NODE_ENV === 'development' ? "price_1SvHzA7tkE7q53KwD1xOS4gh" : "price_1SuYoW9QFSMNCFD5daCRCJWf",
    entity: 'submission',
    quantity: 1000,
};
